const semanticClassNames = {
  root: 'audio-player',
} as const;

export default semanticClassNames;
